<template>
  <div class="common-poster">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>海报分享模板</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">海报分享模板</div>
      </div>
      <!-- <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('common-poster-add');">
          <span>添加模板</span>
        </div>
      </div> -->
    </div>
    <div class="header-switch">
      <div class="header-switch-text">分享设置信息</div> 
    </div>

    <!-- <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="展会海报" name="1">
          <posterEx ref="posterEx" />
        </TabPane>
        <TabPane label="展商海报" name="2">
          <posterExhibitor ref="posterExhibitor" />
        </TabPane>
        <TabPane label="展品海报" name="3">
          <posterExpro ref="posterExpro" />
        </TabPane>
        <TabPane label="活动海报" name="4">
          <posterExact ref="posterExact" />
        </TabPane>
        <TabPane label="供需海报" name="5">
          <posterExsupply ref="posterExsupply" />
        </TabPane>
      </Tabs>
    </div> -->
    <posterEx ref="posterEx" />
  </div>
</template>

<script>
import posterEx from "../components/common-poster-ex.vue";
import posterExhibitor from "../components/common-poster-exhibitor.vue";
import posterExpro from "../components/common-poster-expro.vue";
import posterExact from "../components/common-poster-exact.vue";
import posterExsupply from "../components/common-poster-exsupply.vue";

export default {
  name: "host-common-poster",
  data() {
    return {
      showTabs: "1",
    }
  },
  methods: {
    init() {

    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=ex`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=exhibitor`);
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=expro`);
      } else if (name === "4") {
        this.$router.push(`${this.$route.path}?type=exact`);
      } else if (name === "5") {
        this.$router.push(`${this.$route.path}?type=exsupply`);
      }
    },
  },
  created() {
    // let query = this.$route.query;
    // if (query && query.type && query.type === "ex") {
    //   this.showTabs = "1";
    // }
    // if (query && query.type && query.type === "exhibitor") {
    //   this.showTabs = "2";
    // }
    // if (query && query.type && query.type === "expro") {
    //   this.showTabs = "3";
    // }
    // if (query && query.type && query.type === "exact") {
    //   this.showTabs = "4";
    // }
    // if (query && query.type && query.type === "exsupply") {
    //   this.showTabs = "5";
    // }
  },
  components: {
    posterEx,
    posterExhibitor,
    posterExpro,
    posterExact,
    posterExsupply
  }
}
</script>

<style lang="scss" scoped>
.common-poster {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
}
</style>